// Skills Icons
import jsIcon from "./images/javascript.svg"
import reactIcon from "./images/react.svg"
import androidIcon from "./images/android.svg"
import nodeIcon from "./images/nodejs.svg"
import phpIcon from "./images/php.svg"
import mysqlIcon from "./images/mysql.svg"
import kotlinIcon from "./images/kotlin.svg"
import springIcon from "./images/spring.svg"
import mongoIcon from "./images/mongo.svg"
import platziIcon from "./images/platzi.png"

// Social Icon
import githubIcon from "./images/github.svg"
import linkedInIcon from "./images/linkedin.svg"

export default {
  //(Please Do Not Remove The comma(,) after every variable)
  //Change The Website Template

  //   Header Details ---------------------
  name: "Jean Pierre",
  headerTagline: [
    //Line 1 For Header
    "Software Developer",
    //Line 2 For Header
    "Apps, FrontEnd,",
    //Line 3 For Header
    "and BackEnd",
  ],
  //   Header Paragraph
  headerParagraph:
    "Soy Bachiller graduado en Ciencias de la Computación, me considero un amante del desarrollo de software en todas sus fases y creo fielmente en el aprendizaje continuo.",

  //Contact Email
  contactEmail: "jeanpierre.lara14@gmail.com",

  // End Header Details -----------------------

  // Work Section ------------------------
  projects: [
    {
      title: "ImbaManager", //Project Title - Add Your Project Title Here
      para:
        "Contiene un potente módulo de facturación electrónica basado en la libreria php Greenter, que tiene las funcionalidades para emitir factura, boleta, notas de crédito y débito.", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://portfolio.imbamanager.com/portfolio1_1",
      //Project URL - Add Your Project Url Here
      url: "https://imbamanager.com/",
    },
    {
      title: "ImbaManager", //Project Title - Add Your Project Title Here
      para:
        "Cuenta con módulos de gestión de compra y venta asi como tambien múltiples reportes de nivel contable y gerencial.", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://portfolio.imbamanager.com/portfolio1_2",
      //Project URL - Add Your Project Url Here
      url: "https://imbamanager.com/",
    },
    {
      title: "ImbaManager", //Project Title - Add Your Project Title Here
      para:
        "Tambien cuenta con un módulo de gestión de servicios y actualmente sigue en desarrollo con el fin de escalar a un ERP básico.", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://portfolio.imbamanager.com/portfolio1_3",
      //Project URL - Add Your Project Url Here
      url: "https://imbamanager.com/",
    },
    {
      title: "DekClass", //Project Title - Add Your Project Title Here
      para:
        "Es un proyecto que nace con el fin de ser una herramienta amigable para el usuario docente con dificultades en conocimientos técnico.", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://portfolio.imbamanager.com/portfolio2_1",
      //Project URL - Add Your Project Url Here
      url: "https://dekclass.com/",
    },
    {
      title: "DekClass", //Project Title - Add Your Project Title Here
      para:
        "Contiene funcionalidades de registro de sesiones de clase, foros, videoconferencia, creación de actividades, procesos de evaluación, envío de documentos y sistema de mensajeria de clase.", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://portfolio.imbamanager.com/portfolio2_2",
      //Project URL - Add Your Project Url Here
      url: "https://dekclass.com/",
    },
    {
      title: "DekClass", //Project Title - Add Your Project Title Here
      para:
        "Las videoconferencias y envio de archivos se realizan en la misma sesión del sistema, sin abrir pestañas adicionales.", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://portfolio.imbamanager.com/portfolio2_3",
      //Project URL - Add Your Project Url Here
      url: "https://dekclass.com/",
    },

    /*
    If You Want To Add More Project just Copy and Paste This At The End
    ,{
        title: 'Project Five',
        para: 'Something Amazing',
        imageSrc: "",
        url: ''
    }
    */
  ],

  // End Work Section -----------------------

  // About Secton --------------
  aboutParaOne:
    "Mi nombre es Jean Pierre Lara Arana, soy Bachiller en Ciencias de la Computación egresado de la Universidad Nacional de Trujillo y Desarrollador de Software con más de 3 años de experiencia laboral integrando equipos de desarrollo en diferentes entornos (incluidos equipos locales e internacionales).",
  aboutParaTwo:
    "Disfruto del desarrollo de software, especialmente en proyectos de desarrollo de aplicaciones móviles y sistemas web. Siempre busco nuevos que me permitan aprender constantemente y mejorar como profesional.",
  aboutParaThree:
    `Mi experiencia laboral: 
    <ul style="border-left: 2px solid #e2e2e2;">
      <li style="margin-bottom: 30px">
        <label style="font-weight: bold">Android Developer, Xploring Solutions Sac, Trujillo</label>
        <br />
        <span>(Agosto 2020 — Actualidad)</span>
        <br/>
        <p>Conocimientos adquiridos: Android Studio, Kotlin, Java, Spring Boot y Python</p>      
      </li>

      <li>
        <label style="font-weight: bold">Full Stack Developer, Lidergest Management Academy, Barcelona (Remoto)</label>
        <br />
        <span>(Julio 2018 — Julio 2020)</span>
        <br/>
        <p>Conocimientos adquiridos: HTML, CSS, PHP, Javascript, React, Angular, NodeJS, PHP, Mysql y MongoDB.</p>      
      </li>

    </ul>`,
  aboutImage:
    "https://portfolio.imbamanager.com/fotoPerfil.jpg",

  //   End About Section ---------------------

  // Skills Section ---------------

  //   Import Icons from the top and link it here

  skills: [
    {
      img: reactIcon,
      para:
        "REACT JS",
    },
    {
      img: androidIcon,
      para:
        "ANDROID",
    },
    {
      img: nodeIcon,
      para:
        "NODE JS",
    },
    {
      img: jsIcon,
      para:
        "JAVASCRIPT",
    },
    {
      img: phpIcon,
      para:
        "PHP",
    },
    {
      img: mysqlIcon,
      para:
        "MYSQL",
    },
    {
      img: kotlinIcon,
      para:
        "KOTLIN",
    },
    {
      img: springIcon,
      para:
        "SPRING",
    },
    {
      img: mongoIcon,
      para:
        "MONGO DB",
    },
  ],

  // End Skills Section --------------------------

  //   Promotion Section --------------------------

  promotionHeading: "Heading",
  promotionPara:
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  // End Promotion Section -----------------

  //   Contact Section --------------

  contactSubHeading: "Gracias por visitar este espacio ;)",
  social: [
    // Add Or Remove The Link Accordingly
    { img: githubIcon, url: "https://github.com/JeanPierreLara" },
    {
      img: linkedInIcon,
      url: "https://www.linkedin.com/in/jean-pierre-lara-arana-1b505a167/",
    },
    {
      img: platziIcon,
      url: "https://platzi.com/p/jeanpierre14/",
    },
    
  ],

  // End Contact Section ---------------
}

// Thanks for using this template, I would love to hear from you contact me at hello@chetanverma.com
